<template>
  <div class="w-full h-full rounded-lg flex flex-col gap-2">

    <notificacaoes_agendamentos
      :show="showNotificacoesModal"
      :ordem_servico_id="notificacoesOrdemServicoId"
      :cancel_disabled="notificacoesCancelDisabled"
      @close="fecharNotificacoes"
      @refresh="refreshTable"
    />

    <CriarReorcamentoPopUp
      v-if="showReorcamentoConfirm"
      :item="selectedOrdemParaReorcamento"
      :utilizadores="utilizadoresReorcamento"
      @confirmar="confirmarReorcamento"
      @ignorar="ignorarReorcamento"
      @irParaNegocio="irParaNovoNegocio"
      @close="cancelarReorcamento"
    />

    <div class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema">
      <div class="flex flex-col gap-2">
        <OrdemServicoFilter
          v-if="showFilter"
          @filtersChanged="updateFilters"
          @close-filter="showFilter = false"
        />
        <GenericDataTable
          ref="ordemServicoTable"
          :api-url="`${baseURl}/api/v1/ordemservico/pagination/`"
          :columns="ordemServicoColumns"
          :use-server-side="true"
          :initial-params="currentFilters"
          :default-order-column="0"
          :default-order-direction="'desc'"
          :show_export="true"
          :show_close_btn="false"
          table_title="Lista de Ordens de Serviço"
          @row-click="null"
          @action="handleTableAction"
          @data-loaded="atualizarTotais"
          :nav-actions="['viewDetalhes', 'viewFotos']"
        >
          <template #left-actions>
            <button
              class="action-btn filter-btn relative"
              @click="showFilter = !showFilter"
              title="Filtros"
            >
              <i class="fa-solid fa-filter"></i>
              <span
                v-if="activeFilterCount > 0"
                class="absolute -top-1.5 -right-1.5 bg-blue-500 text-white text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 leading-none"
              >{{ activeFilterCount }}</span>
            </button>
          </template>

          <!-- Sumatorio da coluna Financeiro, sempre sobre os dados filtrados.
               So visivel para quem tem a valencia "Analise Faturacao". -->
          <template #table-summary>
            <div v-if="podeVerAnaliseFaturacao" class="resumo-financeiro">
              <div class="resumo-card">
                <span class="resumo-label">Total Registos</span>
                <span class="resumo-valor">{{ formatNumero(totaisFinanceiros.registos) }}</span>
              </div>
              <div class="resumo-card">
                <span class="resumo-label">Total Previsto</span>
                <span class="resumo-valor">{{ formatMoeda(totaisFinanceiros.previsto) }}</span>
              </div>
              <div class="resumo-card">
                <span class="resumo-label">Total Executado</span>
                <span class="resumo-valor">{{ formatMoeda(totaisFinanceiros.executado) }}</span>
              </div>
              <div class="resumo-card resumo-card--destaque">
                <span class="resumo-label">Total Faturado</span>
                <span class="resumo-valor">{{ formatMoeda(totaisFinanceiros.faturado) }}</span>
              </div>
            </div>
          </template>
        </GenericDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import PdfPreviewDialog from "@/components/dialog/pdfPreviewDialog.vue"; // Importa o componente de PDF
import OrdemServicoFilter from "@/components/filterDataTable/ordemServicoFilter.vue";
import genericPopUp from "@/components/popUps/genericPopUp.vue";
import CriarReorcamentoPopUp from "@/components/popUps/criarReorcamentoPopUp.vue";
import notificacaoes_agendamentos from "@/components/dialog/notificacaoes_agendamentos.vue";
import { getOrdemServicoStatusLabel, getOrdemServicoStatusClass, getOrdemServicoStatusBadgeClass } from "@/utils/ordemServicoStatusLabel";
import { getUser } from "@/extraData";

// Base absoluta da API para os links exportados. Em produção o
// VUE_APP_URL_BASE vem vazio (a API está no mesmo domínio) e os links
// saíam relativos ("/api/v1/..."), inúteis fora da aplicação (ex.: Excel).
const absoluteApiBase = () =>
  new URL(process.env.VUE_APP_URL_BASE || "/", window.location.origin).href.replace(/\/$/, "");

export default {
  name: "OrdemServicoView",
  components: {
    GenericDataTable,
    AppSearch,
    AppNotification,
    AppProfileSearch,
    PdfPreviewDialog,
    OrdemServicoFilter,
    genericPopUp,
    CriarReorcamentoPopUp,
    notificacaoes_agendamentos,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      // refresh: false, // DEPRECATED: No longer needed with GenericDataTable
      // show_table: true, // DEPRECATED: No longer needed with GenericDataTable
      filtroData: {},
      filter_data: {}, // Still used for filter params passed to GenericDataTable
      currentFilters: (() => {
        try {
          const saved = localStorage.getItem("ordemServico_filters");
          if (saved) {
            const state = JSON.parse(saved);
            const active = {};
            for (const [key, val] of Object.entries(state.filters)) {
              if (Array.isArray(val)) {
                if (val.length > 0) active[key] = val.join(',');
              } else if (val !== "" && val !== null && val !== undefined) {
                active[key] = val;
              }
            }
            return active;
          }
        } catch (_) { /* ignore */ }
        return {};
      })(), // Current filter parameters for GenericDataTable
      order_by: "data_inicial",
      page_size: 10,
      showDetails: false,
      selectedOrdem: null,
      showPdfPreview: false, // Estado para mostrar o PDF
      pdfUrl: "", // URL do relatório PDF

      showFilter: false, // Changed to false since filter is commented out
      urlString: "", // DEPRECATED: No longer used (tablefilter removed)
      showGenericPopUp: false,

      selectedOrdemFatura: {
        numeroFatura: "",
        numeroFaturaExtra: "",
        dataFatura: new Date().toISOString().split("T")[0],
        dataFaturaExtra: new Date().toISOString().split("T")[0],
        valorFatura: 0,
        valorFaturaExtra: 0,
        contacto: "",
      },
      modalData: {},

      selectedOrdem: {},
      genericPopUpAttachments: [],

      showReorcamentoConfirm: false,
      selectedOrdemParaReorcamento: null,
      utilizadoresReorcamento: [],

      showNotificacoesModal: false,
      notificacoesOrdemServicoId: null,
      notificacoesCancelDisabled: false,

      // Valencia "Analise Faturacao" — sem ela os cards de totais nao aparecem.
      podeVerAnaliseFaturacao: false,

      // Totais da coluna Financeiro (P/E/F) calculados no backend sobre o
      // conjunto filtrado completo, nao apenas sobre a pagina visivel.
      totaisFinanceiros: {
        registos: 0,
        previsto: 0,
        executado: 0,
        faturado: 0,
      },

      // GenericDataTable column configuration
      // Updated to match actual API response structure
      ordemServicoColumns: [
        {
          key: "ordemServico",
          label: "OS #",
          type: "text",
          sortable: true,
          searchable: true,
          maxWidth: 80,
        },
        {
          key: "status",
          label: "Estado",
          type: "badge",
          sortable: true,
          searchable: true,
          maxWidth: 110,
          computed: (row) => getOrdemServicoStatusLabel(row.status),
          badgeClass: (row, value) => getOrdemServicoStatusBadgeClass(value),
          prefixIcon: (row) =>
            row.notificacao_icon
              ? {
                  html: row.notificacao_icon,
                  action: "verNotificacoes",
                  title: "Ver notificações",
                }
              : null,
        },
        {
          key: "cliente_info",
          label: "Cliente / Sub-Cliente",
          type: "text",
          sortable: true,
          sortKey: "cliente_nome",
          searchable: true,
          maxWidth: 180,
          exportable: false,
          computed: (row) => {
            const cliente = row.cliente_nome || "N/A";
            const subcliente = row.subcliente_nome;
            const lock = row.subcliente_bloqueado
              ? ' <i class="fa-solid fa-lock" style="color:#ef4444" title="Sub-cliente bloqueado"></i>'
              : "";
            if (subcliente && subcliente !== cliente && subcliente !== "N/A") {
              return `<div style="color: var(--text);">${cliente}</div><div style="font-size: 0.85em; color: var(--glass-muted); line-height: 1.2;">${subcliente}${lock}</div>`;
            }
            return `<span style="color: var(--text);">${cliente}${lock}</span>`;
          },
        },
        // Hidden columns for export - Cliente/SubCliente
        { key: "cliente_nome", label: "Cliente", type: "text", visible: false },
        { key: "subcliente_nome", label: "Sub-Cliente", type: "text", visible: false },
        {
          key: "local_familia",
          label: "Local / Família",
          type: "text",
          sortable: true,
          sortKey: "local_instalacao_nome",
          maxWidth: 160,
          exportable: false,
          computed: (row) => {
            const local = row.local_instalacao_nome || "N/A";
            const familia = row.Familia || "N/A";
            return `<div style="line-height: 1.2; color: var(--text);">${local}</div>
              <div style="font-size: 0.75em; text-transform: uppercase; color: var(--glass-muted); font-weight: 600; margin-top: 2px;">
                <i class="fa-solid fa-tag" style="font-size: 0.9em;"></i> ${familia}
              </div>`;
          },
        },
        // Hidden columns for export - Local/Família
        { key: "local_instalacao_nome", label: "Local de Instalação", type: "text", visible: false },
        { key: "Familia", label: "Família", type: "text", visible: false },
        {
          key: "equipa",
          label: "Equipa / Responsáveis",
          type: "text",
          sortable: true,
          sortKey: "Utilizador",
          maxWidth: 180,
          exportable: false,
          computed: (row) => {
            const tecnico = row.Utilizador || "Sem Técnico";
            const gestor = row.gestor_nome || "N/A";
            const comercial = row.comercial_nome || "N/A";

            // Header with the Technician
            let html = `<div title="Técnico" style="font-weight: 500; color: var(--text);"><i class="fa-solid fa-wrench" style="width: 12px; margin-right: 10px;"></i> ${tecnico}</div>`;

            // Logic for Gestor and Comercial
            if (gestor === comercial && gestor !== "N/A") {
              // Show only once if they are the same
              html += `<div style="font-size: 0.8em; color: var(--glass-muted);">G/C: ${gestor}</div>`;
            } else if (gestor !== "N/A" || comercial !== "N/A") {
              // Show both if they are different
              html += `<div style="font-size: 0.8em; color: var(--glass-muted);">G: ${gestor} | C: ${comercial}</div>`;
            }

            return html;
          },
        },
        // Hidden columns for export - Equipa
        { key: "Utilizador", label: "Técnico", type: "text", visible: false },
        { key: "gestor_nome", label: "Gestor", type: "text", visible: false },
        { key: "comercial_nome", label: "Comercial", type: "text", visible: false },
        {
          key: "periodo",
          label: "Período",
          type: "text",
          sortable: true,
          sortKey: "data_inicio",
          maxWidth: 120,
          exportable: false,
          computed: (row) => {
            const formatDate = (dateStr) => {
              if (!dateStr) return "---";
              try {
                const date = new Date(dateStr);
                const day = String(date.getDate()).padStart(2, "0");
                const monthNames = [
                  "Jan",
                  "Fev",
                  "Mar",
                  "Abr",
                  "Mai",
                  "Jun",
                  "Jul",
                  "Ago",
                  "Set",
                  "Out",
                  "Nov",
                  "Dez",
                ];
                const month = monthNames[date.getMonth()];
                const year = date.getFullYear();
                return `${day} ${month} ${year}`;
              } catch {
                return "---";
              }
            };

            const inicio = formatDate(row.data_inicio);
            const fim = formatDate(row.data_fim);
            return `<div style="font-size: 0.9em; line-height: 1.3; color: var(--text);">
                <span style="color: var(--glass-muted); margin-bottom: 5px;">Iní:</span> ${inicio}<br/>
                <span style="color: var(--glass-muted)">Fim:</span> ${fim}
              </div>`;
          },
        },
        // Hidden columns for export - Período
        { key: "data_inicio", label: "Data Início", type: "date", visible: false },
        { key: "data_fim", label: "Data Fim", type: "date", visible: false },
        {
          key: "financeiro",
          label: "Financeiro (P/E/F)",
          type: "text",
          sortable: true,
          sortKey: "valor_previsto",
          maxWidth: 100,
          exportable: false,
          computed: (row) => {
            const p = row.valor_previsto || "0,00 €";
            const e = row.valor_sem_iva || "0,00 €";
            const f = row.total_fatura || "0,00 €";

            return `<div style="line-height: 1.1; font-size: 0.85rem;">
                <div style="color: var(--glass-muted); margin-bottom: 4px;" title="Valor Previsto">P: ${p}</div>
                <div style="color: var(--glass-muted); margin-bottom: 4px;" title="Valor Executado">E: ${e}</div>
                <div style="color: var(--glass-green); font-weight: bold;" title="Valor Faturado">F: ${f}</div>
              </div>`;
          },
        },
        // Hidden columns for export - Financeiro
        { key: "valor_previsto", label: "Valor Previsto", type: "text", visible: false },
        { key: "valor_sem_iva", label: "Valor Executado", type: "text", visible: false },
        { key: "total_fatura", label: "Valor Faturado", type: "text", visible: false },
        // Hidden column for export - Link do Orçamento
        {
          key: "orcamento_link",
          label: "Link Orçamento",
          type: "text",
          visible: false,
          computed: (row) => {
            if (!row.orcamento_id) return "";
            const schema = localStorage.getItem("selectedSchema") || "";
            return `${absoluteApiBase()}/api/v1/pdf/orcamentos/preview/${row.orcamento_id}/?schema=${encodeURIComponent(schema)}`;
          },
          exportValue: (row) => {
            if (!row.orcamento_id) return "";
            const schema = localStorage.getItem("selectedSchema") || "";
            return `${absoluteApiBase()}/api/v1/pdf/orcamentos/preview/${row.orcamento_id}/?schema=${encodeURIComponent(schema)}`;
          },
        },
        // Hidden column for export - Link do Relatório
        {
          key: "relatorio_link",
          label: "Link Relatório",
          type: "text",
          visible: false,
          computed: (row) => {
            if (!row.relatorio_token) return "";
            return `${absoluteApiBase()}/api/v1/pdf/relatorios-token/?token=${row.relatorio_token}&t=${Date.now()}`;
          },
          exportValue: (row) => {
            if (!row.relatorio_token) return "";
            return `${absoluteApiBase()}/api/v1/pdf/relatorios-token/?token=${row.relatorio_token}`;
          },
        },
        // Hidden column for export - Link do Termo de Responsabilidade
        {
          key: "termo_link",
          label: "Link Termo Responsabilidade",
          type: "text",
          visible: false,
          computed: (row) => {
            if (!row.termo_token) return "";
            return `${absoluteApiBase()}/api/v1/pdf/termos-token/?token=${encodeURIComponent(row.termo_token)}`;
          },
          exportValue: (row) => {
            if (!row.termo_token) return "";
            return `${absoluteApiBase()}/api/v1/pdf/termos-token/?token=${encodeURIComponent(row.termo_token)}`;
          },
        },
        {
          key: "orcamento_id",
          label: "Orc.",
          type: "custom-link",
          maxWidth: 70,
          sortable: false,
          exportable: false,
        },
        {
          key: "actions",
          label: "Ações",
          type: "actions",
          maxWidth: 220,
          sortable: false,
          exportable: false,
          actions: [
            {
              type: "viewPdf",
              icon: "fa-solid fa-file-pdf",
              class: "action-icon-btn",
              title: "Ver Relatório PDF",
              showIf: "relatorio_token",
            },
            {
              type: "viewRelatorioProgresso",
              icon: "fa-solid fa-file-pdf",
              class: "action-icon-btn text-yellow-500",
              title: "Ver Relatório de Progresso",
              showIf: (row) => !row.relatorio_token && ["Em Execução", "execução", "Interrompido", "interrompido"].includes(row.status),
            },
            {
              type: "viewTermo",
              icon: "fa-solid fa-file-signature",
              class: "action-icon-btn",
              title: "Ver Termo de Responsabilidade",
              showIf: "termo_token",
            },
            {
              type: "viewFotos",
              icon: "fa-solid fa-images",
              class: "action-icon-btn",
              title: "Ver Fotografias da Intervenção",
              showIf: "has_photos",
            },
            {
              type: "viewDetalhes",
              icon: "fa-solid fa-eye",
              class: "action-icon-btn",
              title: "Ver Detalhes",
            },
            {
              type: "openNegocio",
              icon: "fa-solid fa-briefcase",
              class: "action-icon-btn",
              title: "Ver Negócio",
              showIf: "NegocioID",
            },
            {
              type: "viewRorcamento",
              icon: "fa-solid fa-calculator",
              class: (row) => {
                const colorMap = {
                  em_curso:  "action-icon-btn text-blue-500",
                  concluido: "action-icon-btn text-green-400",
                  ignorado:  "action-icon-btn text-orange-400",
                };
                if (colorMap[row.reorcamento_estado]) return colorMap[row.reorcamento_estado];
                // Sem pedido de reorçamento o icon aparece na mesma, a cinzento,
                // e dá acesso às mesmas ações.
                return row.reorcamentar
                  ? "action-icon-btn text-red-500"
                  : "action-icon-btn text-gray-400";
              },
              title: (row) => {
                const titleMap = {
                  em_curso:  "Reorçamento em curso",
                  concluido: "Reorçamento concluído",
                  ignorado:  "Reorçamento ignorado",
                };
                if (titleMap[row.reorcamento_estado]) return titleMap[row.reorcamento_estado];
                return row.reorcamentar ? "Reorçamentar" : "Criar Orçamento/Corretiva";
              },
              // Há pedido de reorçamento, ou a OS já está fechada: mesmo que o
              // técnico tenha respondido que não era para reorçamentar, o
              // escritório pode criar o orçamento/corretiva a partir daqui.
              showIf: (row) =>
                !!(row.reorcamentar || row.reorcamento_estado || row.reorcamento_disponivel),
            }
            
          ],
        },
      ],
    };
  },
  async mounted() {
    this.carregarValencias();
    try {
      const res = await axios.get(`${this.baseURl}/api/v1/utilizador/s/funcionario_escritorio/`);
      this.utilizadoresReorcamento = res.data.data?.sort((a, b) => a.nome.localeCompare(b.nome)) || [];
    } catch {
      this.utilizadoresReorcamento = [];
    }
  },
  computed: {
    activeFilterCount() {
      const skip = new Set(["data_inicial_fim"]);
      return Object.entries(this.currentFilters).filter(
        ([key, val]) => !skip.has(key) && val !== "" && val !== null && val !== undefined
      ).length;
    },
  },
  methods: {
    // A area de totais so e mostrada a quem tem a valencia "Analise Faturacao".
    async carregarValencias() {
      const userId = getUser()?.id;
      if (!userId) {
        this.podeVerAnaliseFaturacao = false;
        return;
      }
      try {
        const res = await axios.get(
          `${this.baseURl}/api/v1/utilizadorvalencia/s/utilizador_id/${userId}/?exact=true`
        );
        const valencias = res.data?.data || [];
        this.podeVerAnaliseFaturacao = valencias.some(
          (v) => v.tpValencia?.nome === "Análise Faturação"
        );
      } catch (error) {
        console.error("Erro ao carregar valências do utilizador:", error);
        this.podeVerAnaliseFaturacao = false;
      }
    },

    // Guarda os totais devolvidos pela API a cada carregamento da tabela
    // (mudanca de filtros, pesquisa, ordenacao ou pagina).
    atualizarTotais(payload) {
      const totais = payload?.totais;
      this.totaisFinanceiros = {
        registos: Number(totais?.registos ?? payload?.total_count ?? 0),
        previsto: Number(totais?.previsto ?? 0),
        executado: Number(totais?.executado ?? 0),
        faturado: Number(totais?.faturado ?? 0),
      };
    },

    formatNumero(valor) {
      const numero = Number(valor);
      if (!Number.isFinite(numero)) return "0";
      return new Intl.NumberFormat("pt-PT").format(numero);
    },

    formatMoeda(valor) {
      const numero = Number(valor);
      if (!Number.isFinite(numero)) return "0,00 €";
      return new Intl.NumberFormat("pt-PT", {
        style: "currency",
        currency: "EUR",
      }).format(numero);
    },

    // Update filters and refresh table
    updateFilters(filters) {
      // Sem estado selecionado, a lista mostra as OS de todos os estados.
      this.currentFilters = { ...filters };
      this.refreshTable();
    },

    // Refresh table data
    refreshTable() {
      if (this.$refs.ordemServicoTable) {
        this.$refs.ordemServicoTable.refresh();
      }
    },

    handleTableAction({ type, item }) {
      // Handle action events from GenericDataTable
      switch (type) {
        case "viewPdf":
          this.openRelatorioPreview(item);
          break;
        case "viewTermo":
          this.openTermoPreview(item);
          break;
        case "viewFotos":
          this.openFotos(item);
          break;
        case "viewDetalhes":
          this.openDetalhes(item);
          break;
        case "openFatura":
          this.openFatura(item);
          break;
        case "openNegocio":
          this.openNegocio(item);
          break;
        case "view":
          this.visualizarPDFOrcamento(item);
          break;
        case "viewRorcamento":
          this.selectedOrdemParaReorcamento = item;
          this.showReorcamentoConfirm = true;
          break;
        case "viewRelatorioProgresso":
          this.openRelatorioProgresso(item);
          break;
        case "verNotificacoes":
          this.abrirNotificacoes(item);
          break;
      }
    },

    openTermoPreview(row) {
      if (!row.termo_token) return;
      const pdfUrl = `${process.env.VUE_APP_URL_BASE}/api/v1/pdf/termos-token/?token=${encodeURIComponent(row.termo_token)}`;
      window.open(pdfUrl, "_blank");
    },

    openRelatorioProgresso(item) {
      const schema = localStorage.getItem("selectedSchema") || "";
      const baseUrl = process.env.VUE_APP_URL_BASE || this.baseURl;
      const url = `${baseUrl}/api/v1/pdf/relatorios/progresso/${item.NegocioID}/${item.id}/?schema=${encodeURIComponent(schema)}`;
      window.open(url, "_blank");
    },

    abrirNotificacoes(item) {
      this.notificacoesOrdemServicoId = item.id;
      // Agendamentos já iniciados (fechado/interrompido) não podem ser cancelados
      this.notificacoesCancelDisabled = item.pode_cancelar_agendamento === false;
      this.showNotificacoesModal = true;
    },

    fecharNotificacoes() {
      this.showNotificacoesModal = false;
      this.notificacoesOrdemServicoId = null;
      this.notificacoesCancelDisabled = false;
    },

    async confirmarReorcamento({ atribuido_a_id, obs }) {
      this.showReorcamentoConfirm = false;

      const item = this.selectedOrdemParaReorcamento;
      if (!item?.NegocioID) {
        toast.error("Negócio anterior não encontrado.", { position: "top-center", autoClose: 2000 });
        return;
      }

      try {
        await axios.post(`${this.baseURl}/api/v1/negocio/criar-reorcamento/`, {
          negocioAnterior_id: item.NegocioID,
          dataInicial: new Date().toISOString().split("T")[0],
          atribuido_a_id: atribuido_a_id || 0,
          ordemServico_id: item.id,
          descricao: obs || "",
        });
        toast.success("Reorçamento criado com sucesso!", { position: "top-center", autoClose: 2000 });
        this.refreshTable();
      } catch {
        toast.error("Erro ao criar o reorçamento.", { position: "top-center", autoClose: 2000 });
        return;
      }
    },

    async ignorarReorcamento() {
      const item = this.selectedOrdemParaReorcamento;
      this.showReorcamentoConfirm = false;
      this.selectedOrdemParaReorcamento = null;

      try {
        await axios.post(`${this.baseURl}/api/v1/negocio/reorcamento-ignorar/`, {
          ordemServico_id: item.id,
        });
        toast.success("Reorçamento ignorado.", { position: "top-center", autoClose: 2000 });
        this.refreshTable();
      } catch {
        toast.error("Erro ao ignorar o reorçamento.", { position: "top-center", autoClose: 2000 });
      }
    },

    irParaNovoNegocio() {
      const item = this.selectedOrdemParaReorcamento;
      this.showReorcamentoConfirm = false;
      this.selectedOrdemParaReorcamento = null;

      if (!item?.reorcamento_negocio_id) return;

      const url = this.$router.resolve({
        name: "negocio-with-id",
        params: { negocio_id: item.reorcamento_negocio_id },
      });
      window.open(url.href, "_blank");
    },

    cancelarReorcamento() {
      this.showReorcamentoConfirm = false;
      this.selectedOrdemParaReorcamento = null;
    },
    openFotos(ordem) {
      this.$router.push({
        name: "ordemFotos",
        params: { ordem_id: ordem.id },
      });
    },
    openDetalhes(ordem) {
      const url = this.$router.resolve({
        name: "ordemDetalhes",
        params: { ordem_id: ordem.id },
        query: { negocio_id: ordem.NegocioID },
      });
      window.open(url.href, "_blank");
    },
    visualizarPDFOrcamento(item) {
      console.log("Visualizando PDF do orçamento para item:", item);
      if (!item.orcamento_id) {
        toast.error("Orçamento não encontrado", {
          theme: "auto",
          type: "error",
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      const schema = localStorage.getItem("selectedSchema");
      if (!schema) {
        toast.error("Schema não encontrado. Por favor, selecione um esquema.", {
          theme: "auto",
          type: "error",
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      const baseUrl = process.env.VUE_APP_URL_BASE || this.baseURl;
      let pdfUrl;

      pdfUrl = `${baseUrl}/api/v1/pdf/orcamentos/preview/${
        item.orcamento_id
      }/?schema=${encodeURIComponent(schema)}`;

      // if (item.orcamento_token) {
      //   // If token exists, use token endpoint (for finalized orcamentos)
      //   pdfUrl = `${baseUrl}/api/v1/pdf/orcamentos-token/?token=${item.orcamento_token}`;
      // } else {
      //   pdfUrl = `${baseUrl}/api/v1/pdf/orcamentos/preview/${
      //     item.orcamento_id
      //   }/?schema=${encodeURIComponent(schema)}`;
      //   // If no token, use preview endpoint (for draft orcamentos) with schema parameter
      // }

      window.open(pdfUrl, "_blank");
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleDateString("pt-PT");
    },
    getStatusClass(status) { return getOrdemServicoStatusClass(status); },
    getStatusLabel(status) { return getOrdemServicoStatusLabel(status); },
    async select_ordem(ordem) {
      if (!ordem || Object.keys(ordem).length === 0) {
        console.warn("⚠️ Nenhuma ordem de serviço recebida!");
        return;
      }

      // Garante que as chaves essenciais existem
      this.selectedOrdem = ordem;

      let fetched_ordem = await this.select(
        `${this.baseURl}/api/v1/ordemservico/${ordem.id}/`
      );
      fetched_ordem = fetched_ordem.data;
      if (fetched_ordem) {
        this.modalData.Contacto = fetched_ordem.Contacto?.nome || "N/A";
        this.selectedOrdem.Contacto = fetched_ordem.Contacto?.nome || "N/A";
        this.modalData.Negocio = fetched_ordem.Negocio.status;
        // this.selectedOrdem.Cliente = fetched_ordem.Cliente?.nome || "N/A";
        // this.selectedOrdem.SubCliente = fetched_ordem.SubCliente?.nome || "N/A";
        // this.selectedOrdem.LocalInstalacao =
        //   fetched_ordem.LocalInstalacao?.nome || "N/A";
        // this.selectedOrdem.Utilizador = fetched_ordem.Utilizador?.user || "N/A";
      }

      if (fetched_ordem?.Negocio.id) {
        const encomendaData = await this.select(
          `${this.baseURl}/api/v1/encomenda/?negocio_id=${fetched_ordem?.Negocio.id}`
        );
        if (encomendaData && encomendaData.length > 0) {
          const encomenda = encomendaData.find(
            (e) => e.negocio_id === fetched_ordem?.Negocio.id
          );

          if (encomenda) {
            this.modalData.encomenda = {
              id: encomenda.id,
              moeda_id: encomenda.moeda_id,
              total: encomenda.total,
              status: encomenda.status,
              moeda_nome: "Moeda",
            };

            if (encomenda.moeda_id) {
              const moedaInfo = await this.select(
                `${this.baseURl}/api/v1/tpmoeda/${encomenda.moeda_id}/`
              );
              this.modalData.encomenda.moeda_nome = moedaInfo?.nome ?? "Moeda";
            }
          }
        }
      } else {
        console.warn("⚠️ Ordem de serviço não possui negócio_id válido.");
      }
      this.showDetails = true;
    },
    // DEPRECATED: No longer needed with GenericDataTable
    // close_table() {
    //   this.show_table = false;
    // },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleDateString("pt-BR");
    },
    openRelatorioPreview(row) {
      const schema = localStorage.getItem("selectedSchema") || "N/A";
      if (schema === "N/A") {
        toast.error("Por favor, selecione um esquema antes de gerar o PDF.");
        return;
      }

      if (!row.relatorio_token) {
        toast.error("Token do relatório não disponível.");
        return;
      }

      const pdfUrl = `${process.env.VUE_APP_URL_BASE}/api/v1/pdf/relatorios-token/?token=${row.relatorio_token}&t=${Date.now()}`;
      window.open(pdfUrl, "_blank");
    },
    openNegocio(row) {
      console.log("Abrindo negócio para ordem de serviço:", row);
      if (
        row?.NegocioID === null ||
        row?.NegocioID === undefined ||
        row?.NegocioID === 0
      ) {
        return;
      }

      try {
        // Create the URL for the negocio with the ID
        const negocioUrl = this.$router.resolve({
          name: "negocio-with-id",
          params: { negocio_id: row.NegocioID },
        });

        // Open in new tab
        window.open(negocioUrl.href, "_blank");
      } catch (error) {
        console.error("Error opening negocio anterior:", error);
        toast("Erro ao abrir negócio anterior!", {
          theme: "auto",
          type: "error",
          position: "top-center",
          autoClose: 2000,
        });
      }
    },

    // openPdfPreview(ordem) {
    //   console.log("Abrindo relatório para OS:", ordem?.id);
    //   if (!ordem?.id) {
    //     console.warn("⚠️ Nenhum ID encontrado para gerar o relatório!");
    //     return;
    //   }
    //   this.pdfUrl = `${process.env.VUE_APP_URL_BASE}/api/v1/relatoriocliente/pdf/${ordem.id}/?ordem_servico_id=1`;
    //   this.showPdfPreview = true;
    // },

    set_filter(data) {
      console.log("parent data", data);
      const isEmptyObject = (obj) => {
        if (!obj || typeof obj !== "object") {
          return true;
        }
        return Object.keys(obj).length === 0;
      };
      if (isEmptyObject(data)) {
        console.log("im here");
        this.urlString = "ordemservico";
        this.filter_data = JSON.parse(JSON.stringify(data));
        this.showFilter = false;
        // Refresh GenericDataTable
        this.$nextTick(() => {
          if (this.$refs.ordemServicoTable?.refresh) {
            this.$refs.ordemServicoTable.refresh();
          }
        });
        return;
      }
      this.urlString = "ordemservico";
      this.filter_data = JSON.parse(JSON.stringify(data));
      this.showFilter = false;
      // Refresh GenericDataTable
      this.$nextTick(() => {
        if (this.$refs.ordemServicoTable?.refresh) {
          this.$refs.ordemServicoTable.refresh();
        }
      });
    },

    async openFatura(data) {
      if (data.tipoRelatorio != "Definitivo") {
        toast.warning(
          "Só é possível adicionar fatura se o relatório for definitivo."
        );
        return;
      }
      this.selectedOrdem = data;
      const res = await this.select(
        `${this.baseURl}/api/v1/ordemservico/${data.id}/`
      );
      if (res) {
        this.selectedOrdemFatura = {
          numeroFatura: res.data.numeroFatura,
          dataFatura: res.data.dataFatura
            ? res.data.dataFatura.split("T")[0]
            : "",
          valorFatura: res.data.valorFatura || 0,

          numeroFaturaExtra: res.data.numeroFaturaExtra,
          dataFaturaExtra: res.data.dataFaturaExtra
            ? res.data.dataFaturaExtra.split("T")[0]
            : "",
          valorFaturaExtra: res.data.valorFaturaExtra || 0,
        };
        await this.getOrdemPdfs(data.id);
      }
      this.showGenericPopUp = true;
    },

    async saveOrdemFatura(data) {
      if (this.selectedOrdem?.id == 0) {
        return;
      }
      console.log("Fatura data:", data);
      //check if dataFaturaExtra is empty, if so, set it to null
      if (data.dataFaturaExtra == "") {
        data.dataFaturaExtra = null;
      }
      const res = await this.update(
        `${this.baseURl}/api/v1/ordemservico/editar/${this.selectedOrdem.id}/`,
        data
      );
      if (res) {
        toast.success(`Fatura adicionada com sucesso!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.showGenericPopUp = false;
        this.refresh = true;
      } else {
        toast.error(`Erro ao adicionar fatura!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
      // const res = await this.create(data, `${this.baseURl}/api/v1/fatura/registrar/`);
      // if (res) {
      //     toast.success(`Fatura criada com sucesso!`, {
      //         position: toast.POSITION.TOP_CENTER,
      //         autoClose: 1000,
      //     });
      // }
    },
    // DEPRECATED: Export is now handled by GenericDataTable internally
    // export(type) {
    //   console.log("Exporting data:", type);
    // },

    async uploadAttachments(attachmentCopy, modelField) {
      console.log("ordemServico:", this.selectedOrdem);
      try {
        const formData = new FormData();
        // We'll append each selected file under the same key "faturas" or "pdfs"
        for (let i = 0; i < attachmentCopy.length; i++) {
          formData.append("faturas", attachmentCopy[i]);
        }
        formData.append("ordemServico_id", this.selectedOrdem?.id || 0);
        formData.append("numeroFatura", modelField?.numeroFatura);
        // You might also want to send an "ordemServico_id" or something
        // formData.append("ordemServico_id", someId);

        // or any additional data from your model
        // formData.append("someField", this.modelCopy.someField);

        // Make a POST request to your new endpoint

        const res = await axios.post(
          `${this.baseURl}/api/v1/ordemservico/uploadfaturas/`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (res.data && res.data.status === 200) {
          toast.success("PDFs enviados com sucesso!", {
            position: "top-center",
            autoClose: 1000,
          });
          // Reset the attachments
          //attachmentCopy = [];
        } else {
          // Possibly handle an error or different status
          toast.error("Ocorreu um erro ao enviar os PDFs", {
            position: "top-center",
            autoClose: 1500,
          });
        }
      } catch (error) {
        console.error("Erro ao enviar PDFs:", error);
        toast.error("Falha no envio dos PDFs", {
          position: "top-center",
          autoClose: 1500,
        });
      }
    },

    viewAttachment(file) {
      // We will call a backend endpoint with the file’s name
      // For example: /api/v1/ordemservico/faturas/download?filename=...
      // or some custom route that returns the PDF
      // Then we can open it in a new tab/window

      // If you have an "ordemServico_id" or other info, pass it along too
      console.log("Selected file:", file);
      const ordemServicoId = this.selectedOrdem?.id || 0;
      const fileName = file; // "fa_{negocio_id}_{ordem_servico_id}.{numeroFatura}_{something}.pdf"
      console.log("file object in viewAttachment:", file);
      console.log("fileName is:", fileName);
      const url = `${
        this.baseURl
      }/api/v1/ordemservico/faturas/view?ordem_servico_id=${ordemServicoId}&filename=${encodeURIComponent(
        fileName
      )}`;
      this.pdfUrl = url;
      this.showPdfPreview = true;
      // Just open in a new tab:
      //window.open(url, "_blank");
    },

    async getOrdemPdfs(ordemServicoId) {
      try {
        // 1) Fetch the list of PDFs
        const res = await axios.get(
          `${this.baseURl}/api/v1/ordemservico/faturas/list/${ordemServicoId}/`
        );
        if (res.data && res.data.status === 200) {
          const attachments = res.data.data.attachments; // array of filenames

          // 2) Then open your genericPopUp, passing attachments as a prop

          this.genericPopUpAttachments = attachments; // store in a data property or something
        } else {
          // handle errors
          console.error("Erro ao listar faturas", res.data);
        }
      } catch (error) {
        console.error("Erro ao buscar faturas:", error);
      }
    },

    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return true;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
  },
};
</script>

<style scoped>
.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}

.resumo-financeiro {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.resumo-card {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.6rem 0.85rem;
  border-radius: 0.5rem;
  background: var(--fundoComponente);
  border: 1px solid var(--glass-border);
}

.resumo-card--destaque {
  border-color: var(--glass-green, var(--glass-border));
}

.resumo-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 600;
  color: var(--glass-muted);
}

.resumo-valor {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text);
  white-space: nowrap;
}

.resumo-card--destaque .resumo-valor {
  color: var(--glass-green, var(--text));
}

@media (max-width: 900px) {
  .resumo-financeiro {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
